import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { OrderAdminListQuery, OrderResult, OrdersPageResult } from '../../../../core/services/orders/order.models';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { ORDER_STATUS } from '../../../../core/services/orders/orders.constant';

@Injectable()
export class DashboardPreordersService implements Resolve<any>
{
    orders: OrderResult[] = [];
    total = 0;
    page = 0;
    limit = 10;
    search = '';
    sortBy: string;
    sortDirection: string;
    status: string;
    from: Date;
    to: Date;
    operator: string;
    category: string;
    onOrdersChanged: BehaviorSubject<OrderResult[]> = new BehaviorSubject([]);

    constructor(
        private readonly ordersService: OrdersService,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        // return new Promise((resolve, reject) => {
        //     Promise.all([
        //         this.getOrders()
        //     ]).then(
        //         () => {
        //             resolve();
        //         },
        //         reject
        //     );
        // });
    }

    loadOrders(query: OrderAdminListQuery = {}): Promise<OrdersPageResult>
    {
        if (typeof query.status !== 'undefined') {
            this.status = query.status;
        }
        if (typeof query.from !== 'undefined') {
            this.from = query.from;
        }
        if (typeof query.to !== 'undefined') {
            this.to = query.to;
        }
        if (typeof query.operator !== 'undefined') {
            this.operator = query.operator;
        }
        if (typeof query.category !== 'undefined') {
            this.category = query.category;
        }
        if (typeof query.page === 'number') {
            this.page = query.page;
        }
        if (typeof query.limit === 'number') {
            this.limit = query.limit;
        }
        if (typeof query.search !== 'undefined') {
            this.search = query.search;
        }
        if (typeof query.sortBy !== 'undefined') {
            this.sortBy = query.sortBy;
        }
        if (typeof query.sortDirection !== 'undefined') {
            this.sortDirection = query.sortDirection;
        }

        return new Promise((resolve, reject) => {
            this.ordersService.listAdminPage({
                status: this.status,
                from: this.from,
                to: this.to,
                operator: this.operator,
                category: this.category,
                page: this.page,
                limit: this.limit,
                search: this.search,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection,
            })
                .subscribe((response) => {
                    this.orders = response.items;
                    this.total = response.total;
                    this.page = response.page;
                    this.limit = response.limit;
                    this.onOrdersChanged.next(this.orders);
                    resolve(response);
                }, reject);
        });
    }

    getOrders(status?: string, from?:Date, to?: Date, operator?: string, category?: string, page?: number, limit?: number, search?: string, sortBy?: string, sortDirection?: string)
    {
        return this.loadOrders({
            status,
            from,
            to,
            operator,
            category,
            page,
            limit,
            search,
            sortBy,
            sortDirection,
        });
    }

    delete(id: string) {
        return this.setStatus(id, ORDER_STATUS.PREORDER_CANCELED);
    }

    setStatus(id: string, status: string) {
        return new Promise((resolve, reject) => {
            this.ordersService.setStatus(id, status)
                .subscribe((response) => {
                    resolve(response);
                }, reject);
        });
    }

    getStatusClass(status: string) {
        return this.ordersService.getStatusClass(status);
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/preorders/preorders.service.ts